import { render, staticRenderFns } from "./TheProductCardImages.vue?vue&type=template&id=2986fef3&scoped=true"
import script from "./TheProductCardImages.vue?vue&type=script&lang=js"
export * from "./TheProductCardImages.vue?vue&type=script&lang=js"
import style0 from "./TheProductCardImages.vue?vue&type=style&index=0&id=2986fef3&prod&lang=scss"
import style1 from "./TheProductCardImages.vue?vue&type=style&index=1&id=2986fef3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2986fef3",
  null
  
)

export default component.exports